/* eslint-disable import/prefer-default-export */
import { isObject } from "common/utils/core";

const APP_MONITORING_KEY = "__APP_MONITORING__";
const DATADOG_SHIM_WRAPPED_KEY = "datadogShimWrapped";

const getFlags = () => {
  const flags = window[APP_MONITORING_KEY]?.flags;
  return {
    datadogEnabled: flags?.datadogEnabled !== false,
    honeybadgerEnabled: flags?.honeybadgerEnabled === true
  };
};

const reportToDatadog = (messageOrError, options = {}) => {
  try {
    if (!window.DD_RUM || typeof window.DD_RUM.addError !== "function") return;

    // Extract context (Honeybadger supports both options.context and options directly)
    let callSiteContext = {};
    if (isObject(options)) {
      // If options.context exists, use it; otherwise use options itself
      callSiteContext = isObject(options.context) ? options.context : options;
    }

    const globalContext = window[APP_MONITORING_KEY]?.context || {};
    const globalUser = window[APP_MONITORING_KEY]?.user || {};
    const mergedContext = { ...globalContext, ...globalUser, ...callSiteContext };

    if (messageOrError instanceof Error) {
      window.DD_RUM.addError(messageOrError, mergedContext);
    } else {
      const error = new Error(messageOrError);
      error.name = "CustomError";
      window.DD_RUM.addError(error, mergedContext);
    }
  } catch (_e) {
    // Observability must never crash the app.
  }
};

export const installHoneybadgerShim = () => {
  const { datadogEnabled, honeybadgerEnabled } = getFlags();
  if (!datadogEnabled) return;

  const honeybadger = window.Honeybadger;
  if (honeybadger && typeof honeybadger.notify === "function") {
    if (honeybadger[DATADOG_SHIM_WRAPPED_KEY] === true) return;

    const originalNotify = honeybadger.notify.bind(honeybadger);
    honeybadger.notify = (messageOrError, options = {}) => {
      let result;
      if (honeybadgerEnabled) {
        try {
          result = originalNotify(messageOrError, options);
        } catch (e) {
          // If Honeybadger fails, still report to Datadog for dual-write redundancy
        }
      }
      reportToDatadog(messageOrError, options);
      return result;
    };
    honeybadger[DATADOG_SHIM_WRAPPED_KEY] = true;
    return;
  }

  window.Honeybadger = {
    notify: (messageOrError, options = {}) => {
      reportToDatadog(messageOrError, options);
    },
    [DATADOG_SHIM_WRAPPED_KEY]: true
  };
};
